package com.essntl.features.task.ui.sharedtask

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.itinerary.domain.model.ItineraryModel

data class SharedTaskState(
    val getAllItineraries: State<List<ItineraryModel>> = State(),
)
